/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './Subheading.style';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  layoutClass?: string,
  withError?: boolean,
  withWarning?: boolean,
  withDisabled?: boolean,
  // $FlowIssue
  children?: React.Node,
};

const useStyles = createUseStyles(styles);

const Subheading = ({
  layoutClass,
  withError,
  withWarning,
  withDisabled,
  children,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-withError']]: withError,
    [classes['root-withWarning']]: withWarning,
    [classes['root-withDisabled']]: withDisabled,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <h2 className={rootClasses}>{children}</h2>;
};

export default compose(React.memo)(Subheading);
